import { Box, Button, CircularProgress, useTheme } from '@mui/material'
import React from 'react'

const CustomButton = ({ buttonName, fullWidth, color, disabled, href, target, onClick, outline, isLoading }) => {
    const theme = useTheme();
    const colorMappings = {
        primary: `#5bbba9 !important`,
        secondary: "#8592a3 !important",
        tertiary: "red !important",
        success: '#67c932 !important',
        error: "#ff3e1d !important",
        warning: "#ffab00 !important",
        info: "#13C2C2 !important",
        whiteSpace: 'nowrap',
        fontFamily: "Quicksand",
        textTransform: 'none'
    };

    const outlineColorMappings = {
        primary: "#5bbba9",
        secondary: "#8592a314",
        success: "#71dd3714",
        error: "#ff3e1d14",
        warning: "#ffab0014",
        info: "#13C2C2",
        whiteSpace: 'nowrap',
        fontFamily: "Quicksand",
        textTransform: 'none'
    };

    return (
        <Box>
            {!outline && <Button fullWidth={fullWidth} sx={{
                backgroundColor: disabled ? theme.palette.background.disabled : colorMappings[color] || "",
                color: disabled ? `${theme.palette.grey[500]} !important` : theme.palette.common.white,
                padding: '10px 20px',
                borderRadius: "6px",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                whiteSpace: 'nowrap',
            }}
                onClick={onClick}
                href={href}
                target={target}
                disabled={disabled}>
                {isLoading ? <CircularProgress size={14} sx={{ marginRight: "5px" }} color="inherit" /> : ""}
                {buttonName}
            </Button>}
            {outline && <Button fullWidth={fullWidth} sx={{
                backgroundColor: 'transparent',
                color: `${colorMappings[color]}`,
                padding: '7px 20px',
                fontWeight: "500",
                border: `1px solid ${colorMappings[color]}`,
                whiteSpace: 'nowrap',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: disabled ? "#dbdbeb1f" : outlineColorMappings[color] || "",
                    color: "#ffffff !important"
                }
            }}
                onClick={onClick}
                href={href}
                target={target}
                disabled={disabled}>
                {isLoading ? <CircularProgress size={14} sx={{ marginRight: "5px" }} color="inherit" /> : ""}
                {buttonName}
            </Button>}
        </Box>
    )
}

export default CustomButton;


